<div *ngIf="isLoadingForm" class="spinner-div">
  <mat-spinner class="spinner-cls"></mat-spinner>
</div>

<ng-container *ngIf="!isLoadingForm">
  <div [ngSwitch]="formType" class="usan-form-contents">
    <ng-container *ngSwitchCase="'single-entity-drug-salt'">
      <app-single-entity-drug-salt-form class="full-width"></app-single-entity-drug-salt-form>
    </ng-container>
    <ng-container *ngSwitchCase="'single-entity'">
      <app-single-entity-form class="full-width"></app-single-entity-form>
    </ng-container>
    <ng-container *ngSwitchCase="'modified-salt'">
      <app-modified-salt-form class="full-width"></app-modified-salt-form>
    </ng-container>
    <ng-container *ngSwitchCase="'revision-to-adopted-usan'">
      <app-revision-to-adopted-usan-form class="full-width"></app-revision-to-adopted-usan-form>
    </ng-container>
    <ng-container *ngSwitchCase="'contact-lens-material'">
      <app-contact-lens-material-form class="full-width"></app-contact-lens-material-form>
    </ng-container>
    <ng-container *ngSwitchCase="'biologics'">
      <app-biologics-form class="full-width"></app-biologics-form>
    </ng-container>
  </div>
</ng-container>